
define(
	'Code25.shipping'
	, [
		"underscore", "jQuery", "Profile.Model", "Tools", "Utils"
	]
	, function (
		_, jQuery, ProfileModel, Tools, Utils
	) {
		'use strict';

		return {
			mount: function (container) {

				var OrderWizardModuleShipmethod = require("OrderWizard.Module.Shipmethod");

				_.extend(OrderWizardModuleShipmethod.prototype, {

					getContext: _.wrap(OrderWizardModuleShipmethod.prototype.getContext, function (getContext) {

						var res = getContext.apply(this, _.rest(arguments));
						var lines = this.model.get("lines");

						var itemid;
						for (var i = 0; i < lines.models.length; i++) {
							itemid = lines.models[i].get("item").get("itemid");
							if (itemid && itemid.substring(0, 2) == "79") {
								res.hasHeatTransfer = true;
							}
							if (!lines.models[i].get("item").getStockInfo().isInStock) {
								res.hasOutOfStock = true;
							}
							if (itemid && (itemid.substring(0, 2) == "50" || itemid.substring(0, 2) == "52")) {
								res.hasGarments = true;
							}
						}
						res.shippingMethods.sort(function (a, b) {
							if (a.name.indexOf("Collection")>-1) return 1;
							if (b.name.indexOf("Collection")>-1) return -1;
						})
						// console.log(res);
						return res;

					})
				});

			}
		};

	});
